'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _OutgoingMessageActions = require('conversations-core/actions/OutgoingMessageActions');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _outgoingMessagesSelectors = require('conversations-core/selectors/outgoingMessagesSelectors');

var _PubNubMessageSerializer = require('conversations-schema/serializers/PubNubMessageSerializer');

var _conversationSelectors = require('conversations-core/selectors/conversationSelectors');

var _strings = require('conversations-core/constants/strings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var THIRY_SECONDS_IN_MS = 30000;

var PUBLISH_NEXT_MESSAGE_ACTIONS = (0, _immutable.List)([_ActionTypes2.default.CONVERSATIONS_CLIENT_READY, _ActionTypes2.default.ENQUEUE_OUTGOING_MESSAGE, _ActionTypes2.default.PUBLISH_OUTGOING_MESSAGE_SUCCESS, _ActionTypes2.default.PUBLISH_OUTGOING_MESSAGE_FAILURE]);

var PUBLISH_COMPLETE_ACTIONS = (0, _immutable.List)([_ActionTypes2.default.PUBLISH_OUTGOING_MESSAGE_SUCCESS, _ActionTypes2.default.PUBLISH_OUTGOING_MESSAGE_FAILURE]);

exports.default = function (store) {
  return function (next) {
    var publishTimeoutId = null;

    var setPublishTimeout = function setPublishTimeout(_ref) {
      var channel = _ref.channel,
          message = _ref.message;

      publishTimeoutId = setTimeout(function () {
        window.Raven.captureMessage('PUBLISH_TIMEOUT', {
          extra: { message: (0, _PubNubMessageSerializer.serialize)(message), channel: channel }
        });

        store.dispatch((0, _OutgoingMessageActions.publishOutgoingMessageFailure)({ channel: channel, message: message }));
      }, THIRY_SECONDS_IN_MS);
    };

    var clearPublishTimeout = function clearPublishTimeout() {
      return clearTimeout(publishTimeoutId);
    };

    return function (action) {
      var nextAction = next(action);

      var canPublishMessage = (0, _clientSelectors.getCanPublishMessage)(store.getState());
      var hasOutgoingMessages = (0, _outgoingMessagesSelectors.getHasOutgoingMessages)(store.getState());

      if (PUBLISH_COMPLETE_ACTIONS.includes(action.type) && publishTimeoutId) {
        clearPublishTimeout();
      }

      if (PUBLISH_NEXT_MESSAGE_ACTIONS.includes(action.type) && canPublishMessage && hasOutgoingMessages) {
        var _getFirstOutgoingMess = (0, _outgoingMessagesSelectors.getFirstOutgoingMessage)(store.getState()),
            queuedChannel = _getFirstOutgoingMess.channel,
            queuedMessage = _getFirstOutgoingMess.message;

        var channel = queuedChannel !== _strings.INITIAL_ONLINE_MODE_CHANNEL ? queuedChannel : (0, _conversationSelectors.getCurrentChannel)(store.getState());

        setPublishTimeout({ channel: channel, message: queuedMessage });
        store.dispatch((0, _OutgoingMessageActions.publishOutgoingMessage)({ channel: channel, message: queuedMessage }));
        store.dispatch((0, _OutgoingMessageActions.shiftOutgoingMessages)());
      }

      return nextAction;
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/middleware/PublishingMiddleware.js
// module id = 486
// module chunks = 0